import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Role, TeamMember } from './types';

interface UserManagementState {
  memberModal: {
    open: boolean;
    member: TeamMember | null;
  };
  deleteModal: {
    open: boolean;
    member: TeamMember | null;
  };
  createRoleModalOpen: boolean;
  selectedRole: Role | null;
}

const initialState: UserManagementState = {
  memberModal: {
    open: false,
    member: null,
  },
  deleteModal: {
    open: false,
    member: null,
  },
  createRoleModalOpen: false,
  selectedRole: null,
};

const userManagementSlice = createSlice({
  name: 'userManagement',
  initialState,
  reducers: {
    openAddMemberModal: state => {
      state.memberModal = {
        open: true,
        member: null,
      };
    },
    openEditMemberModal: (state, action: PayloadAction<TeamMember>) => {
      state.memberModal = {
        open: true,
        member: action.payload,
      };
    },
    closeMemberModal: state => {
      state.memberModal = initialState.memberModal;
    },
    openDeleteMemberModal: (state, action: PayloadAction<TeamMember>) => {
      state.deleteModal = {
        open: true,
        member: action.payload,
      };
    },
    closeDeleteMemberModal: state => {
      state.deleteModal = initialState.deleteModal;
    },
    openCreateRoleModal: state => {
      state.createRoleModalOpen = true;
    },
    closeCreateRoleModal: state => {
      state.createRoleModalOpen = false;
    },
    openRoleDetailsModal: (state, action: PayloadAction<Role>) => {
      state.selectedRole = action.payload;
    },
    closeRoleDetailsModal: state => {
      state.selectedRole = null;
    },
    resetUserManagementState: () => initialState,
  },
});

export const {
  openAddMemberModal,
  openEditMemberModal,
  closeMemberModal,
  openDeleteMemberModal,
  closeDeleteMemberModal,
  openCreateRoleModal,
  closeCreateRoleModal,
  openRoleDetailsModal,
  closeRoleDetailsModal,
  resetUserManagementState,
} = userManagementSlice.actions;

export default userManagementSlice.reducer;
